import { FC } from "react";
import { Brick } from "components/Atoms/Brick";
import { ChevronRight } from "components/Icons/ChevronRight";
import { ResourceDivider } from "../ResourceDivider";

interface MobileBrickProps {
  title: string;
  subTitle?: string;
  href?: string;
  id: string;
  onClick: () => void;
}

const MobileBrickTab: FC<MobileBrickProps> = ({ title, subTitle = "", href = "", id, onClick }) => {
  return (
    <div className="relative flex">
      <ResourceDivider />

      <Brick
        href={href}
        title={title}
        subTitle={subTitle}
        hoverEffect={false}
        key={id}
        isTab
        className="px-6"
        onClick={onClick}
      />
      {!href && (
        <ChevronRight
          height={12}
          width={12}
          className="pointer-events-none absolute right-7 top-1/2 h-3 w-3 -translate-y-1/2"
        />
      )}
    </div>
  );
};

export { MobileBrickTab };
